import { SafeAreaView, StyleSheet, ViewProps } from 'react-native'
import { infoForError, titleForError, useStore } from 'zens-store'
import { Color, Spacing, Text } from 'zens-storybook'
import { useTranslation } from 'react-i18next'
import { observer } from 'mobx-react-lite'

import TestResult from './result'

const styles = StyleSheet.create({
  container: {
    flex: 1,
    paddingVertical: Spacing.L,
  },
  title: {
    textAlign: 'center',
    marginHorizontal: Spacing.M,
  },
  failed: {
    backgroundColor: Color.darkRed,
  },
  light: {
    color: Color.simplyWhite,
  },
  info: {
    marginTop: Spacing.L,
    marginHorizontal: Spacing.M,
    textAlign: 'center',
  },
})

interface Props extends ViewProps {}

const TestFailed = (props: Props) => {
  const { style, ...otherProps } = props
  const { test } = useStore()
  const { t } = useTranslation()

  const errorTitle = () => {
    return titleForError(test.error, t)
  }

  const errorInfo = () => {
    return infoForError(test.error, t)
  }

  return (
    <SafeAreaView style={[styles.container, styles.failed, style]} {...otherProps}>
      <Text style={[styles.title, styles.light]} level={3}>
        {errorTitle()}
      </Text>
      <Text style={[styles.info, styles.light]}>{errorInfo()}</Text>
      <TestResult />
    </SafeAreaView>
  )
}

export default observer(TestFailed)
